import {
  CustomButton,
  CustomImage,
  CustomModal,
  errorDialog,
  successDialog,
  Text,
  useText,
} from '@src/components';
import modalClose from '@src/assets/icons/icon-close.svg';
import excelIcon from '@src/assets/images/cardOrders/img-excel.png';
import infoButton2 from '@src/assets/icons/np-warning-189701-000000.png';
import React, { useCallback, useState, useEffect } from 'react';
import xlsx from '@src/utils/xlsx';
import { Upload } from 'antd';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import cardOrderDetailsServices from '@src/services/cardOrderDetails.services';
import { cardOrderDetailsGelAll } from '@src/store/slice/cardOrderDetailtsSlice';
import { cardOrdersSave, getCardOrders } from '@src/store/slice/cardOrderSlice';
import '@src/styles/cardOrder/uploadFileModal.scss';
import PropTypes from 'prop-types';
import addCarPlateInformationServices from '@src/services/addNewCar/addCarPlateInformation.services';

const UploadFileModal = ({
  modalVisible,
  handleModalVisible,
  addNewPlate = false,
  customerId,
  deviceTypeId,
  setExcelPlatesArray,
  isCompliments = false,
  isMarket = false,
  currentCardType = 0,
  setComplimentExcelUpload,
  vehicleFuelTypes = null,
  vehicleDepartments = null,
  vehicleCostCenters = null,
  vehicleTypes = null,
  vehicleAttributes = null,
  vehicleLimitTypesDayRestrictionOperations = null,
  vehicleLimitValueTypes = null,
  vehicleLAddressGetList = null,
}) => {
  const yourTransactionHasBeenSuccessfullyCompleted = useText('yourTransactionHasBeenSuccessfullyCompleted');
  const uploadExcel = useText('uploadExcel');
  const isMobil = useMediaQuery({ query: '(max-width: 991.98px)' });
  const stateCardOrder = useSelector((state) => state?.cardOrder);
  const dispatch = useDispatch();
  const [errorList, setErrorList] = useState([]);
  const [isScroll, setIsScroll] = useState(false);

  const saveDetail = async (readData, cardOrderId) => {
    let sequenceNo = 2;
    if (readData.length === 0) {
      return errorDialog({
        title: <Text t="error" />,
        message: 'Yüklediğiniz excelde kayıt bulunmuyor kontrol ediniz.',
      });
    }
    if (addNewPlate) {
      try {
        sequenceNo = 1;
        let platesArray = [];
        const tempData = readData.map((item, index) => {
          if (item?.plate) {
            const platesArrayLength = platesArray.length + 1;
            platesArray.push({
              id: platesArrayLength,
              label: 'Plaka ' + platesArrayLength.toString(),
              name: 'plate' + platesArrayLength.toString(),
              plate: item.plate?.toString()?.toUpperCase(),
            });
          }
          let tempItem = { ...item };
          let flag = true;
          let checkVT = vehicleTypes?.findIndex(
            (vT) => vT?.vehicleTypeName.toString() === tempItem?.vehicleType?.split(' - ')[1],
          );
          if (checkVT === -1) {
            flag = false;
          } else if (
            vehicleTypes[checkVT].vehicleTypeId.toString() !==
            tempItem?.vehicleType?.split(' - ')[0]
          ) {
            tempItem.vehicleType =
              vehicleTypes[checkVT].vehicleTypeId.toString() +
              ' - ' +
              vehicleTypes[checkVT].vehicleTypeName;
          }

          let checkFT = vehicleFuelTypes?.findIndex(
            (vT) => vT?.fuelTypeLabel.toString() === tempItem?.segment?.split(' - ')[1],
          );
          if (checkFT === -1) {
            flag = false;
          } else if (
            vehicleFuelTypes[checkFT].fuelTypeId.toString() !== tempItem?.segment?.split(' - ')[0]
          ) {
            tempItem.segment =
              vehicleFuelTypes[checkFT].fuelTypeId.toString() +
              ' - ' +
              vehicleFuelTypes[checkFT].fuelTypeLabel;
          }

          let checkA = vehicleAttributes?.findIndex(
            (vT) =>
              vT?.vehicleAttributeName.toString() === tempItem?.vehicleUsageType?.split(' - ')[1],
          );
          if (checkA === -1) {
            flag = false;
          } else if (
            vehicleAttributes[checkA].vehicleAttributeId.toString() !==
            tempItem?.vehicleUsageType?.split(' - ')[0]
          ) {
            tempItem.vehicleUsageType =
              vehicleAttributes[checkA].vehicleAttributeId.toString() +
              ' - ' +
              vehicleAttributes[checkA].vehicleAttributeName;
          }

          if (tempItem?.limitType) {
            let checkLT = vehicleLimitTypesDayRestrictionOperations?.findIndex(
              (vT) => vT?.limitTypeLabel.toString() === tempItem?.limitType?.split(' - ')[1],
            );
            if (checkLT === -1) {
              flag = false;
            } else if (
              vehicleLimitTypesDayRestrictionOperations[checkLT].limitTypeId.toString() !==
              tempItem?.limitType?.split(' - ')[0]
            ) {
              tempItem.limitType =
                vehicleLimitTypesDayRestrictionOperations[checkLT].limitTypeId.toString() +
                ' - ' +
                vehicleLimitTypesDayRestrictionOperations[checkLT].limitTypeLabel;
            }
          }

          if (tempItem?.limitValueType) {
            let checkLVT = vehicleLimitValueTypes?.findIndex(
              (vT) =>
                vT?.limitValueTypeLabel.toString() === tempItem?.limitValueType?.split(' - ')[1],
            );
            if (checkLVT === -1) {
              flag = false;
            } else if (
              vehicleLimitValueTypes[checkLVT].id.toString() !==
              tempItem?.limitValueType?.split(' - ')[0]
            ) {
              tempItem.limitValueType =
                vehicleLimitValueTypes[checkLVT].id.toString() +
                ' - ' +
                vehicleLimitValueTypes[checkLVT].limitValueTypeLabel;
            }
          }

          if (tempItem?.deliveryAddress && vehicleLAddressGetList?.length > 0) {
            let checkAd = vehicleLAddressGetList?.findIndex(
              (vT) =>
                vT?.companyAddress.toString().trim() ===
                tempItem?.deliveryAddress?.split(' - ')[1].trim(),
            );
            if (checkAd === -1) {
              flag = false;
            } else if (
              vehicleLAddressGetList[checkAd].id.toString() !==
              tempItem?.deliveryAddress?.split(' - ')[0]
            ) {
              tempItem.deliveryAddress =
                vehicleLAddressGetList[checkAd].id.toString() +
                ' - ' +
                vehicleLAddressGetList[checkAd].companyAddress;
            }
          }

          if (tempItem?.department && vehicleDepartments?.length > 0) {
            let checkD = vehicleDepartments?.findIndex(
              (vT) => vT?.label.toString().trim() === tempItem?.department?.split(' - ')[1].trim(),
            );
            if (checkD === -1) {
              flag = false;
            } else if (
              vehicleDepartments[checkD].id.toString() !== tempItem?.department?.split(' - ')[0]
            ) {
              tempItem.department =
                vehicleDepartments[checkD].id.toString() + ' - ' + vehicleDepartments[checkD].label;
            }
          }
          if (tempItem?.costCenter && vehicleCostCenters?.length > 0) {
            let checkCC = vehicleCostCenters?.findIndex(
              (vT) =>
                vT?.costCenterLabel.toString().trim() ===
                tempItem?.costCenter?.split(' - ')[1].trim(),
            );
            if (checkCC === -1) {
              flag = false;
            } else if (
              vehicleCostCenters[checkCC].costCenterId.toString() !==
              tempItem?.costCenter?.split(' - ')[0]
            ) {
              tempItem.costCenter =
                vehicleCostCenters[checkCC].costCenterId.toString() +
                ' - ' +
                vehicleCostCenters[checkCC].costCenterLabel;
            }
          }
          if (flag) {
            const tempPrice =
              tempItem?.limitType &&
                tempItem?.limitValueType &&
                tempItem?.limit &&
                typeof tempItem?.limit === 'number'
                ? `${tempItem?.limit || 0}`.replaceAll('.', ',')
                : '0';
            return {
              customerId: customerId,
              vouId: 4,
              plate: tempItem.plate?.toString()?.toUpperCase() || null,
              deviceTypeId: deviceTypeId,
              vehicleType: tempItem?.vehicleType?.toString() || null,
              vehicleUsageType: tempItem?.vehicleUsageType?.toString() || null,
              segment: tempItem?.segment?.toString() || null,
              deliveryAddress: tempItem?.deliveryAddress?.toString() || null,
              department: tempItem?.department?.toString() || null,
              costCenter: tempItem?.costCenter?.toString() || null,
              limitType: tempItem?.limitType?.toString() || null,
              limitValueType: tempItem?.limitValueType?.toString() || null,
              price: tempPrice,
              priceStr: tempPrice,
              driverName: tempItem?.driverName?.toString() || null,
              driverGsm: tempItem?.driverGsm?.toString() || null,
              driverEmail: tempItem?.driverEmail?.toString() || null,
              sequenceNo: sequenceNo + index,
            };
          }
        });
        const data = tempData?.filter((tD) => tD?.plate);
        const responseCreateVehicleExcelUpload =
          await addCarPlateInformationServices.createVehicleExcelUpload({
            createVehicleExcelDtoLists: data,
          });
        setExcelPlatesArray({
          platesArray,
          data: responseCreateVehicleExcelUpload?.data?.createVehicleExcelDtoLists,
        });
        successDialog({
          title: <Text t="success" />,
          message: yourTransactionHasBeenSuccessfullyCompleted,
        });

        handleModalVisible(false);
      } catch (error) {
        console.error(error);
        error?.data?.data?.forEach((item, index) => {
          setErrorList((state) => [
            ...state,
            {
              id: index,
              message: item,
            },
          ]);
        });
      }
    } else if (isCompliments || isMarket) {
      try {
        const data = readData.map((item, index) => {
          return {
            name: item?.name?.toString() || null,
            surname: item?.surname?.toString() || null,
            refNo: item?.refNo?.toString() || null,
            gsm: item?.gsm?.toString() || null,
            deliveryAddress: item?.deliveryAddress?.toString() || null,
            priceStr:
              typeof item?.price === 'number'
                ? `${item?.price || 0}`.replaceAll('.', ',')
                : `${item?.price || 0}`,
            sequenceNo: sequenceNo + index,
            cardOrderId: cardOrderId,
            vouId: isMarket ? 11 : 94,
            mobilePaymentAuthorization: !!currentCardType,
          };
        });

        await cardOrderDetailsServices.setCardOrderDetailExcelUpload({
          cardOrderDetailExcelDtoLists: data,
        });
        successDialog({
          title: <Text t="successfullyUploaded" />,
          message: 'Excel dosyanız başarıyla ile yüklendi.',
        });
        setComplimentExcelUpload({ data });
        await dispatch(getCardOrders({ id: stateCardOrder?.currentCardOrder?.id }));
        await dispatch(cardOrderDetailsGelAll({ pageNumber: 1, pageSize: 10 }));
        handleModalVisible(false);
      } catch (error) {
        error?.data?.data?.forEach((item, index) => {
          setErrorList((state) => [
            ...state,
            {
              id: index,
              message: item,
            },
          ]);
        });
      }
    } else {
      try {
        const data = readData.map((item, index) => {
          return {
            name: item?.name?.toString() || null,
            surname: item?.surname?.toString() || null,
            refNo: item?.refNo?.toString() || null,
            gsm: item?.gsm?.toString() || null,
            deliveryAddress: item?.deliveryAddress?.toString() || null,
            priceStr:
              typeof item?.price === 'number'
                ? `${item?.price || 0}`.replaceAll('.', ',')
                : `${item?.price || 0}`,
            sequenceNo: sequenceNo + index,
            cardOrderId: cardOrderId,
          };
        });

        await cardOrderDetailsServices.setCardOrderDetailExcelUpload({
          cardOrderDetailExcelDtoLists: data,
        });
        successDialog({
          title: <Text t="success" />,
          message: yourTransactionHasBeenSuccessfullyCompleted,
        });
        await dispatch(getCardOrders({ id: stateCardOrder?.currentCardOrder?.id }));
        await dispatch(cardOrderDetailsGelAll({ pageNumber: 1, pageSize: 10 }));
        handleModalVisible(false);
      } catch (error) {
        error?.data?.data?.forEach((item, index) => {
          setErrorList((state) => [
            ...state,
            {
              id: index,
              message: item,
            },
          ]);
        });
      }
    }
  };

  const setFile = useCallback(
    (file) => {
      const reader = new FileReader();
      const rABS = !!reader?.readAsBinaryString;
      reader.onload = async (e) => {
        try {
          const bStr = e?.target?.result;
          const wb = xlsx.read(bStr, { type: rABS ? 'binary' : 'array', bookVBA: true });
          /* Get first worksheet */
          const wsName = wb?.SheetNames[0];
          const ws = wb?.Sheets[wsName];
          /* Convert array of arrays */
          if (addNewPlate) {
            const readData = xlsx.utils?.sheet_to_json(ws, {
              header: [
                'plate',
                'vehicleType',
                'vehicleUsageType',
                'segment',
                'deliveryAddress',
                'department',
                'costCenter',
                'limitType',
                'limitValueType',
                'limit',
                'driverName',
                'driverGsm',
                'driverEmail',
              ],
              range: 1,
            });
            await saveDetail(readData);
          } else {
            const readData = xlsx.utils?.sheet_to_json(ws, {
              header: ['name', 'surname', 'refNo', 'gsm', 'deliveryAddress', 'price'],
              range: 0,
            });
            if (readData.length > 0 && readData[0].refNo === 'Referans Numarası') {
              readData.splice(0, 1);
            }
            if (
              readData.length > 0 &&
              readData[readData.length - 1]?.name === 'Toplam Kart Sayısı:'
            ) {
              readData.splice(-1);
            }
            const { id, cardOrderDetails, ...cardOrderBody } = stateCardOrder?.currentCardOrder;
            if (id === 0) {
              const action = await dispatch(cardOrdersSave(cardOrderBody));
              if (cardOrdersSave.fulfilled.match(action)) {
                await saveDetail(readData, action?.payload?.data?.id);
              } else {
                handleModalVisible(false);
              }
            } else {
              await saveDetail(readData, id);
            }
          }
        } catch (error) {
          console.error(error);
        }
      };

      if (rABS) {
        reader?.readAsBinaryString(file);
      } else {
        reader?.readAsArrayBuffer(file);
      }
    },
    [stateCardOrder?.currentCardOrder, dispatch, handleModalVisible, saveDetail, addNewPlate],
  );

  const beforeUpload = (file) => {
    const isExcel = [
      '.csv',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
    ].includes(file.type);

    if (!isExcel) {
      setErrorList((state) => [
        ...state,
        {
          id: errorList.length,
          message: 'Lütfen Excel yükleyiniz. Başka bir dosya yükleyemezsiniz.',
        },
      ]);
    }

    const isLt2M =
      addNewPlate || isCompliments || isMarket
        ? file.size / 1024 / 1024 < 100
        : file.size / 1024 / 1024 < 10;

    if (!isLt2M) {
      setErrorList((state) => [
        ...state,
        {
          id: errorList.length,

          message:
            addNewPlate || isCompliments || isMarket
              ? 'Lütfen 100 MB ve altında bir Excel yükleyiniz.'
              : 'Lütfen 10 MB ve altında bir Excel yükleyiniz.',
        },
      ]);
    }

    if (isExcel && isLt2M) {
      setErrorList([]);
      setFile(file);
    }
    return false;
  };

  const handleClose = useCallback(
    (e) => {
      e.stopPropagation();
      handleModalVisible(false);
      setErrorList([]);
    },
    [handleModalVisible],
  );

  useEffect(() => {
    if (!modalVisible) {
      setIsScroll(false);
    }
  }, [modalVisible]);

  return (
    <CustomModal
      className="upload-file-modal"
      width={689}
      maskClosable={false}
      footer={false}
      title={uploadExcel}
      visible={modalVisible}
      onCancel={handleClose}
      closeIcon={<CustomImage src={modalClose} />}
    >
      <Upload
        className={!errorList.length ? '' : 'upload-list-inline error'}
        name="excel"
        listType="picture-card"
        showUploadList={false}
        multiple={false}
        beforeUpload={beforeUpload}
        customRequest={() => { }}
        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      >
        <div className="file-uploader">
          <CustomImage src={excelIcon} />
          {isMobil === true ? (
            <h5>
              <Text t="uploadYourExcelFile" />
            </h5>
          ) : (
            <h5>
              <Text t="dragOrUploadYourExcelFileToThis2" />
            </h5>
          )}

          <div className="mute-text">
            <Text t="xlsAndXlsxMaxSize100Mb" />
          </div>
          <div className="action-btn">
            <CustomButton
              id="ticketRestaurant-cardOrders-cardInformation-uploadFileModal-cancel-btn"
              className="cancel-btn"
              onClick={handleClose}
            >
              <Text t="giveUp" />
            </CustomButton>

            <CustomButton
              id="ticketRestaurant-cardOrders-cardInformation-uploadFileModal-add-btn"
              className="add-btn"
            >
              <Text t="browse" />
            </CustomButton>
          </div>
        </div>
      </Upload>

      {errorList.length > 0 && (
        <div className="error-messages">
          <div className="error-title">
            <CustomImage src={infoButton2} className="error-title-icon" />
            <span className="error-title-content">
              <Text t="anErrorOccurredWhileUploadingYourExcelFile" />
            </span>
          </div>
          <div className="errors-body">
            <div className="message-detail-list">
              <p>
                <Text t="errorDetails" />
              </p>
              <div
                className="message-list"
                style={{
                  overflowY: isScroll ? 'scroll' : 'hidden',
                }}
              >
                {errorList.map((item) => {
                  return <span key={item?.id}>{item?.message}</span>;
                })}
              </div>
            </div>

            {!isScroll && errorList.length >= 10 ? (
              <div className="action-show-errors">
                <span
                  onClick={() => {
                    return setIsScroll(true);
                  }}
                >
                  <Text t="showAllErrors" />
                </span>
              </div>
            ) : null}
          </div>
        </div>
      )}
    </CustomModal>
  );
};

UploadFileModal.propTypes = {
  handleModalVisible: PropTypes.func,
  addNewPlate: PropTypes.bool,
  modalVisible: PropTypes.bool,
  customerId: PropTypes.any,
  deviceTypeId: PropTypes.any,
  setExcelPlatesArray: PropTypes.func,

  isCompliments: PropTypes.bool,
  isMarket: PropTypes.bool,
  setComplimentExcelUpload: PropTypes.func,

  vehicleFuelTypes: PropTypes.any,
  vehicleDepartments: PropTypes.any,
  vehicleCostCenters: PropTypes.any,
  vehicleTypes: PropTypes.any,
  vehicleAttributes: PropTypes.any,
  vehicleLimitTypesDayRestrictionOperations: PropTypes.any,
  vehicleLimitValueTypes: PropTypes.any,
  vehicleLAddressGetList: PropTypes.any,

  currentCardType: PropTypes.number,
};

export default UploadFileModal;
